import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-athorized-page',
    templateUrl: './not-athorized-page.component.html',
    styleUrls: ['./not-athorized-page.component.css']
})
export class NotAthorizedPageComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
